import "./NorthFortMyersPestControl.module.css";
import Header from "@/reusable_sections/Header";
import NorthFortMyersPestControlHero from "./sections/NorthFortMyersPestControlHero";
import NorthFortMyersPestServices from "./sections/NorthFortMyersPestServices";
import LocalPestGrid from "./sections/LocalPestGrid";
import PestControlProcessTimeline from "./sections/PestControlProcessTimeline";
import PestControlFeatures from "./sections/PestControlFeatures";
import ClimateResistantComparison from "./sections/ClimateResistantComparison";
import NorthFortMyersFaq from "./sections/NorthFortMyersFaq";
import NorthFortMyersLocalServiceProvider from "./sections/NorthFortMyersLocalServiceProvider";
import NorthFortMyersServiceArea from "./sections/NorthFortMyersServiceArea";
import NorthFortMyersFreeInspectionCta from "./sections/NorthFortMyersFreeInspectionCta";
import Footer from "@/reusable_sections/Footer";
export default function NorthFortMyersPestControlPage() {
  return <div>
      <Header />
      <NorthFortMyersPestControlHero />
      <NorthFortMyersPestServices />
      <LocalPestGrid />
      <PestControlProcessTimeline />
      <PestControlFeatures />
      <ClimateResistantComparison />
      <NorthFortMyersFaq />
      <NorthFortMyersLocalServiceProvider />
      <NorthFortMyersServiceArea />
      <NorthFortMyersFreeInspectionCta />
      <Footer />
    </div>;
}